import React from "react";
import CustomNav from "../../components/general/CustomNav";
import {ContentNav} from "../../services/interface/content-nav";
import TableResult from "./TableResult";
import useInputValue from "../../hooks/useInputValue";
export default function Trays() {
    const [nav, setNav] = React.useState<string>('approved')
    const search = useInputValue('')
    const content: ContentNav[] = [
        {
            id: 'approved',
            label: 'approved',
            desc: <TableResult nav={'approved'} {...{search}}/>,
        },
        {
            id: 'pending-review',
            label: 'pending-review',
            desc: <TableResult nav={'pending-review'} {...{search}}/>,
        },
        {
            id: 'denied',
            label: 'denied',
            desc: <TableResult nav={'denied'} {...{search}}/>,
        }
    ];

    return(
        <div className={'max-w-[1200px] mx-auto min-h-[80vh] flex flex-col gap-2'}>
            <CustomNav {...{nav, setNav, content}}/>
        </div>
    )
}
